import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHtml5Component } from './simple-icons-html5.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHtml5Component ],
    exports:      [ SimpleIconsHtml5Component ],
    bootstrap:    []
})
export class SimpleIconsHtml5Module {}
